import React, { useState, useEffect } from 'react';
 
import { Link, useNavigate } from "react-router-dom";
 
import  {  IconButton,Tooltip,Zoom,Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useDispatch } from 'react-redux';
import host from '../../host';
import { changeAuth } from '../../actions/loginAction';
export default function HeaderPage() {
const dispatch = useDispatch();
const navigate = useNavigate();
const [isActive, setIsActive] = useState(() => localStorage.getItem('isActive') === 'true');
const handleToggleClick = () => {
setIsActive(!isActive);
localStorage.setItem('isActive', !isActive);
};
useEffect(() => {
if (isActive) {
document.body.classList.add('mini-sidebar');
} else {
document.body.classList.remove('mini-sidebar');
}
}, [localStorage.getItem('isActive')]);

const [open, setOpen] = useState(false); 
const handleDrawer = () => {
setOpen(!open);
};
const [anchorEl, setAnchorEl] = React.useState(null);
const open2 = Boolean(anchorEl);
const handleClick = (event) => {
setAnchorEl(event.currentTarget);
};
const handleClose = () => {
setAnchorEl(null);
};

//profile functionality begins

const [profile, setProfile] = useState(null);
// const [isLoaded, setIsLoaded] = useState(false);
const [snackbar, setSnackbar] = useState(false);
const [message, setMessage] = useState("");
const [severity, setSeverity] = useState("success");
const onClose = () => {
    setSnackbar(false);
  };

const getProfile = () => {
   // setIsLoaded(false);
   fetch(host.chaturl + `/user`, {
     method: "GET",
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + localStorage.getItem("token"),
     },
   })
     .then((res) => {
       if (res.ok) {
         return res.json();
       } else if (res.status === 403) {
         dispatch(changeAuth(false, null));
         navigate("/logout");
       } else {
         // setIsLoaded(true);
         setSeverity("error");
         setMessage("Something went wrong");
         setSnackbar(true);
       }
     })
     .then((data) => {
       if (data) {
         setProfile(data);
         // setIsLoaded(true);
       }
     })
     .catch((err) => {
       console.log(err);
      //  setIsLoaded(true);
     });
 };

 useEffect(() => {
   getProfile();
 }, []);


//profile functionality ends

return (
<>
<header id="page-topbar">
   <div className="navbar-header">
      <div className="d-flex align-items-center">
         {/* LOGO */}
         {/* <div className="navbar-brand-box">
          
               <Link to="/" className=" ">
               <div className="logo-icon">
           
               
            <img src={logoicon} />
            
         </div>
               <h6>HRMS</h6>
               </Link>
          
         </div> */}
          <div className='minimize_sidebar'>
         <IconButton aria-label="hide" onClick={handleToggleClick}>
            <MenuIcon /> 
         </IconButton>
      </div>
         {/* App Search*/}
      </div>
      <div className="d-flex align-items-center  gap-3 ml-auto ">
 
         {/* <div className="settings border-right head_right_icon">
         <Tooltip className="blue-tooltip"  title="New Chat" placement="top" arrow>
            <Link to="/">
                       <button type='button' className='btn btn-primary'> <AddIcon/> New Chat</button> 
                       </Link>
                     </Tooltip>
         </div> */}


         <div className="settings border-right head_right_icon">
         {/* <div className='minimize_sidebar'>
         <IconButton aria-label="hide" onClick={handleToggleClick}>
            <QuestionMarkIcon /> 
         </IconButton>
         </div> */}
         </div>
         <div className="user-profile border-right head_right_icon">
         <div className="user-profile-head">
         <Tooltip title="Profile" TransitionComponent={Zoom} placement="top" arrow>
            <Link to="/my-account">
            <div className="user-profile-pick">
               <Avatar> {profile
                          ? profile.fullname
                              .split(/\s/)
                              .reduce(
                                (response, word) =>
                                  (response += word.slice(0, 1)),
                                ""
                              )
                          : "NA"}</Avatar>
            </div>
            <div className="user-profile-content">
                      <span className="user-name">
                        {" "}
                        {profile ? profile.fullname : "NA"}
                      </span>
                      <span>{profile ? profile.email : "NA"}</span>
                    </div>
            </Link>
         </Tooltip>
      </div>
      
         </div>
      </div>
   </div>
</header>
</>
)
}